import { Component, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { LeadDetailsService } from '../../../services/lead-details.service';
import { ReferralDataService } from '../../../services/referral-data.service';
import { SectionsService } from '../../../services/sections.service';
import { AuthorizationUtility } from '../../../shared/authorization/auth.utility';
import { AuthorizationService } from '../../../shared/authorization/authorization.service';
import { PAGE_CONSTANTS } from '../../../shared/constants/page.constants';
import { ASSOCIATION_TYPE_SEARCH_VALUES, STATIC_DATA } from '../../../shared/constants/static-data.constants';
import { SharedDataService } from '../../../shared/services/shared-data-service';
import { ParticipantLeadsListComponent } from '../../participant-leads-list/participant-leads-list.component';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { AuthorizeButtonDirective } from '../../../shared/authorization/authorizeButton.directive';
import { ButtonComponent } from '../../../shared/components/button/button.component';
import { ListTableComponent } from '../../../shared/components/list-table/list-table.component';
import { UserService } from '../../../services/user.service';
import { StorageService } from '../../../services/storage.service';
import { LookupValueItem } from '../../../interfaces/lookup.interface';
import { AutoFocusHeaderDirective } from '../../../shared/directives/auto-focus-header.directive';

@Component({
  selector: 'ppl-participant-enrollment-list',
  standalone: true,
  imports: [ListTableComponent,
    NzIconModule,
    NzButtonModule,
    RouterModule,
    AuthorizeButtonDirective,
    ButtonComponent,
    AutoFocusHeaderDirective],
  templateUrl: './participant-enrollment-list.component.html',
  styleUrl: './participant-enrollment-list.component.css'
})
export class ParticipantEnrollmentListComponent extends ParticipantLeadsListComponent implements OnInit{
  override sharedDataKey: string = STATIC_DATA.SHARED_PARTICIPANT_ENROLLMENT_DATA;
  override pageId: string = PAGE_CONSTANTS.PARTICIPANT_ENROLLMENT_DATA_GRID_PAGE;
  contactStsReasonLkpList: LookupValueItem[] = [];
  drReviewNeededSearchValues = [
    { lkpValueName: 'Yes', lkpValueCode: 'Yes' },
    { lkpValueName: 'No', lkpValueCode: 'No' },
  ];
  applicationStatusSearchValues: LookupValueItem[] = [];
  associationTypeSearchValues = ASSOCIATION_TYPE_SEARCH_VALUES;

  constructor(
    router: Router,
    sectionService: SectionsService,
    referralDataService: ReferralDataService,
    sharedDataService: SharedDataService,
    authUtility: AuthorizationUtility,
    authService: AuthorizationService,
    userService: UserService,
    private leadDetailsService: LeadDetailsService,
    private storageService: StorageService
  ) {
    super(
      router,
      sectionService,
      referralDataService,
      sharedDataService,
      userService,
      authUtility,
      authService,
    );
  }

  override onNewLead(): void {
    this.router.navigate(['/referralLogic']);
    this.sectionService.setFlow('providers');
    this.referralDataService.clearReferrralData();
  }

  override ngOnInit(): void {
    this.contactStsReasonLkpList = this.lookupService.getLookupValue('contact_status_reason_lkp');
    this.applicationStatusSearchValues = this.lookupService.getLookupValue('Participant_Enrollment_status');
    super.ngOnInit()
  }

  onNewReferral() {
    this.router.navigate(['/newReferral']);
    this.sectionService.setFlow('providerEnrollment');
    this.userService.setLeadEntry('');
    this.referralDataService.clearReferrralData();
  }

  onNewEnrollment() {
    this.router.navigate(['/newReferral']);
    this.storageService.setParticipantId("");
    this.sectionService.setFlow('participantEnrollment');
    this.userService.setLeadEntry('');
    this.userService.setSelectedLead('');
    this.referralDataService.clearReferrralData();
  }

  override rowClicked(rowDetail: any) {
    const program = this.userService.getSelectedProgram();
    this.userService.setLeadEntry('participantEnrollment');
    this.sectionService.setFlow('participantEnrollment');
    this.referralDataService.clearReferrralData();

    this.userService.setSelectedLead(rowDetail.participant_id);  //rowDetail.referral_participant_id
    this.userService.setParticipantPplId(rowDetail.participant_ppl_id)
    if (rowDetail.application_status_lkp == 'New Application' || rowDetail.application_status_lkp == 'In Progress') {
      this.leadDetailsService
        .fetchLeadDetailsApi(
          'participantEnrollment',
          program ? program.program_code : '',
          rowDetail.participant_id
        )
        .subscribe((data: any) => {
          this.referralDataService.setReferralDetails(data.responsedata);
          setTimeout(() => {
            this.storageService.setParticipantId(data?.responsedata?.infoData.participantId );
            this.storageService.setParticipantPPLId(data.responsedata?.infoData.participantPPLId);
            this.storageService.setTrackingNumber(data.responsedata?.infoData.trackingNumber);
            this.router.navigate(['/newReferral']);
          }, 200);
        });
    } else {
      setTimeout(() => {
        this.router.navigate(['/home/participantEnrollmentList/details/'], { state: { navigateTo: '/home/participantEnrollmentList' } });
      }, 200);
    }
  }

}
